
const zh = {
  loginText:"登录/注册",
  header: {
    back: "返回",
    menus:  [
      {name:"首页","path":"home"},
      {name:"天琴","path":"tianqin"},
      {name:"射手","path":"sheshou"},
      {name:"临渊","path":"linyuan"},
      // {name:"仙后","path":"xianhou"},
      // {name:"泰坦","path":"taitan"},
      //{name:"接口","path":"interface"},
      {name:"联系我们","path":"contact"}
    ]
  },
  footer:{
    title1:"商务合作",
    title2:"广告主合作",
    per1:"联系人:崔女士",
    per2:"联系人:王女士",
    qq1:"QQ:331291204",
    qq2:"QQ:719459791",
    projectList:[{name:'天琴',path:'/tianqin'},{name:'射手',path:"/sheshou"},{name:'临渊',path:'/linyuan'},
        // {name:'仙后',path:'/xianhou'},{name:'泰坦',path:'/taitan'},
        {name:'联系我们',path:"/contact"},{name:'网际星辰',href:"http://www.star-media.cn/"}],
  },
  taitan: {
    banTitle: "泰坦风控系统",
    banTips: "基于AI+区块链技术的风控引擎",
    summary: {
      tit1: "AI数据分析",
      tips1: [
        "非人类流量识别：基于用户行为数据、用户设备物理信息，结合AI数据分析，从用户行为习惯的各个维度综合评判，甄别出非人类流量。",
        "低质人类流量筛查：对通过非人类流量甄别的流量，结合用户长期历史行为轨迹数据，以及用户与内容或广告之间的交互数据，筛选分离出低质量人类流量。"
      ],
      tit2: "区块链护航",
      tips2: [
        "泰坦风控引擎将利用区块链的不可篡改特性，通过智能合约将风控分析结果数据上链，提高风控引擎的安全性与可信度。"
      ]
    },
    four:[
      {t:"一站式接入", p:"专业咨询服务，一站式接入"},
      {t:"专业后台", p:"操作简单，使用方便"},
      {t:"优质团队", p:"产品、研发、运营、售后全覆盖"},
      {t:"坐享收益", p:"高效率变现，高转化，高收益"},
    ]
  },
  linyuan: {
    banTitle: "临渊",
    banTips: "基于AI的发现搜索平台",
    summary: {
      tit1: "AI赋能",
      tips1: [
        "运用AI技术，捕捉用户行为数据，建立了丰富的基础标签和个性化标签体系，保证了临渊可以将当下热⻔、用户感兴趣的内容分发出去，在贡献收⼊的同时，也为流量主的APP提升了留存、活跃和使用时⻓。",
      ],
      tit2: "智能搜索",
      tips2: [
        "相比传统的应用内搜索，临渊可以为流量主提供更多稳定的增量收入：临渊在新闻监控、搜索热词挖掘、个性化分发等⽅⾯投⼊了大量的精力。"
      ],
      tit3: "热点追踪",
      tips3: [
        "覆盖全网的热点监控能力，对于新增热点事件做到分钟级跟进，对全网实时热点进行分析及热度发展预估，智能化分发给兴趣点更高的用户群体"
      ],
    },
    p1: "基于AI的发现搜索平台，接入对象为内容类、任务类等各大流量APP，针对没有搜索习惯的用户，通过个性化的热词的推荐引导，帮助用户发现实时的搜索热点，教育和培养搜索的行为习惯，同时为流量APP带来丰厚的商业收入",

  },
  xianhou: {
    banTitle: "仙后意图引擎",
    banTips: "基于深度学习的意图引擎",
    summary: {
      tit1: "用户意图感知",
      tips1: [
        "通过NLP技术结合用户不同时期的浏览内容，获得并提取用户短期与中长期兴趣，了解用户真实意图。",
      ],
      tit2: "意图推荐模型",
      tips2: [
        "推荐模型以基于NLP获取的用户真实意图属性，结合候选内容或广告属性，并辅以媒体属性，为用户推荐或选择符合其意图的内容或广告。"
      ],
    }
  },
  sheshou: {
    banTitle: "射手",
    banTips: "休闲SDK",
    summary: {
      tit1: "我们比您更懂您的用户",
      tips1:[
        "经过多年数字营销、用户产品矩阵、内容提供服务，积累了海量的用户行为数据，让我们更了解您的用户",
      ],
      tit2: "覆盖用户量超过8亿",
      tips2:[
        "聚合SDK多通道智能流量分发策略，提高流量变现效率，帮助媒体实现收益最大化。",
      ],
      tit3: "样式灵活 入口丰富",
      tips3:[
        {name:"通栏",isshow:true},
        {name:"底部悬浮",isshow:false},
        {name:"开屏",isshow:false},
        {name:"固定块",isshow:false},
        {name:"信息流",isshow:false},
        {name:"弹窗",isshow:false},
      ],
    },
  },
  tianqin: {
    banTitle: "天琴",
    banTips: "PC/H5流量变现平台",
    summary: {
      tit1: "千家媒体接入",
      tips1:[
        "每日广告展现量过10亿，同时结合自主研发的风控系统，帮助媒体过滤低质流量，提升eCPM。"
      ],
      tit2: "专业的事交给专业的团队",
      tips2:[
        "团队核心成员来自于百度，小米等商业产品团队，有着丰富的产品和运营经验。"
      ],
      tit3: ["样式灵活","入口丰富"],
      tips3:[
        {name:"固定块",isshow:true},
        {name:"悬浮广告",isshow:false},
        {name:"对联",isshow:false},
        {name:"信息流",isshow:false},
      ],
    },
    desc:[
     {n:"一站式接入",d:"专业咨询服务，一站式接入"},
     {n:"专业后台",d:"操作简单，使用方便"},
     {n:"优质团队",d:"产品、研发、运营、售后全覆盖"},
     {n:"坐享收益",d:"高效率变现，高转化，高收益"}
    ]
  },
  tianqinpromoter:{
    summary: {
      tit1: "网盟流量接入推广员",
      tips1:[
        "资源既是财富，天琴PC/H5流量变现平台期待着引入更多的优质流量，如果正巧您有相关流量资源（网站或APP内流量）请一定不要浪费，推荐并引导这些流量接入天琴系统并使用天琴的广告代码进行变现。在帮这些流量挣到一份良好收益的同时，天琴也将为您提供一份可观的佣金（视流量规模与质量及最终变现数据而定）。"
      ],
      tips2:["欲知详情请联系页面底部商务合作"]
    }
  },
  xcpinyuepartner:{
    banTitle: "星辰品阅",
    banTips: "",
    summary: {
      tit1: "电商供应链伙伴",
      tips1:[
        "资源既是财富，我司已在各类电商平台上设立店铺，并能通过当前火热的直播获取可观流量，为更好的服务于用户，我司现需要建立更为广泛的商品供应链，为自身店铺提供更加丰富和优质的实物商品，如果您恰巧有认识的生产厂商（最好支持商品定制），可以向我司推荐，一旦其后续成为我们的产品供应商，您作为我们的供应链合作伙伴将从今后的每件产品销售中获得可观的分成收益。"
      ],
      tips2:["欲知详情请联系页面底部商务合作"]
    }
  },
  interface:{
    tabBar:["天琴","射手","临渊"],
    tianqinTab:['简介','运行首个C#程序','声明和使用变量','使用字符串','发掘字符串的更多精彩用途','搜索字符串']
  },
  contact: {
    banTitle: "联系我们",
    banTips: "CONTACT US",
    summary: {
      tit1: "地址",
      tips1: "北京市通州区新潞运河文创园B1-3",
      tit2: "电话",
      tips2: "010-82157368-8001",
      tit3: "Email",
      tips3: "cuisiqi@star-media.cn"

    }
  },
  openaccount: {
    banTitle: "广告主开户流程",
    summary: {
      tit1: "<h4 class='oah4'>广告主开户需通过邮件申请</h4>",
      tips1: "邮件标题：申请开通星辰+广告主账号<br/>" +
      "收件人：renshaowei@star-media.cn<br/>" +
      "邮件内容：<span class='oared'>（以下信息务必全部提供）</span><br/>广告主名称<br/>" +
      "广告主所属公司名称<br/>" +
      "广告主所属公司网站URL地址<br/>" +
      "电子邮箱<br/>" +
      "手机号<br/>" +
      "广告主推广产品所属行业类型或者广告主所属行业类型（一级行业和二级行业都要提供，<span class='oablue'>行业类型下载</span>）",
      tit2: "<h4 class='oah4'>查收广告主账号开通成功的通知邮件，发件人为 <span class='oared'>【星辰+广告平台】service@star-media.cn</span></h4>",
      tips2: "网际星辰的客服收到开户申请邮件后，会帮助广告主在广告平台创建账户，创建成功后，系统会以邮件的形式将账号信息发送给广告主",
      tit3: "<h4 class='oah4'>使用邮件内的账号密码登录广告主平台完善账户信息</h4>",
      tips3: "广告主平台地址： <br/><span class='oablue'>http://advertiser.iscrv.com/ </span>"

    }
  },
  metaInfoData: {
    title:"星辰+",
    description:"星辰+，是网际星辰旗下的一站式变现平台，对于PC，H5，APP，小程序等不同产品形式，以及不同的变现场景，都有相对应的样式，预算和接入方式来帮助开发者，团队核心成员来自于百度，小米等商业产品团队，有着丰富的产品和运营经验，星辰+平台现已接入近千家媒体，每日广告展现量过10亿。",
    projectList:[
      {
        projectName: "天琴",
        keywords: "天琴，广告平台，星辰加，一站式变现，大数据，AI",
        description: "PC/H5广告平台",
        path:"/tianqin"
      },
      {
        projectName: "射手",
        keywords: "射手，广告平台，星辰加，一站式变现，大数据，AI",
        description: "休闲SDK",
        path:"/sheshou"
      },
      {
        projectName: "临渊",
        keywords: "临渊，搜索平台，智能搜索，热点追踪，星辰加，一站式变现，大数据，AI",
        description: "基于AI的发现搜索平台",
        path:"/linyuan"
      },
    ],
    home: {
      title: "星辰+",
      keywords: "专业的,一站式流量变现,服务平台",
      description:
      "星辰+，是网际星辰旗下的一站式变现平台，对于PC，H5，APP，小程序等不同产品形式，以及不同的变现场景，都有相对应的样式，预算和接入方式来帮助开发者，团队核心成员来自于百度，小米等商业产品团队，有着丰富的产品和运营经验，星辰+平台现已接入近千家媒体，每日广告展现量过10亿。"
    },
    taitan: {
      title: "泰坦风控系统",
      keywords: "AI数据分析，区块链",
      description: "基于AI+区块链技术的风控引擎"
    },
    linyuan: {
      title: "临渊",
      keywords: "临渊，搜索平台，智能搜索，热点追踪，星辰加，一站式变现，大数据，AI",
      description: "基于AI的发现搜索平台"
    },
    xianhou: {
      title: "仙后意图引擎",
      keywords: "仙后，意图引擎，AI，机器学习，意图感知，意图推荐模型，NLP",
      description: "基于深度学习的意图引擎"
    },
    qianfanyun: {
      title: "网际星辰-千帆云",
      keywords:
      "千帆云，内容生态，saas服务解决方案，全站移动化，云内容，云广告，短视频，直播，分类信息，互动营销",
      description: "新兴市场内容生态综合服务平台"
    },
    tianqin: {
      title: "网际星辰-天琴",
      keywords: "天琴，广告平台，星辰加，一站式变现，大数据，AI",
      description: "PC/H5广告平台"
    },
    sheshou: {
      title: "网际星辰-射手",
      keywords: "射手，广告平台，星辰加，一站式变现，大数据，AI",
      description: "IN-APP广告平台"
    },
    contact: {
      title: "网际星辰-联系我们",
      keywords: "网际星辰,网星传媒,网星，网际星辰电话，网际星辰地址",
      description: "网际星辰文化传媒（北京）有限公司是一家专注于移动互联网内容生态的高新技术企业，利用“AI+大数据”驱动智慧融媒体的发展。公司创业十年历程中，始终秉承科技创新的理念，坚持以客户需求为产品研发的原始驱动力和方向，坚定地打造一个有责任、有担当的一站式变现服务平台。"
    },
    news: {
      title: "网际星辰-新闻动态",
      keywords: "网际星辰,网星传媒,网星，网星新闻",
      description: "网际星辰文化传媒（北京）有限公司是一家专注于移动互联网内容生态的高新技术企业，利用“AI+大数据”驱动智慧融媒体的发展。公司创业十年历程中，始终秉承科技创新的理念，坚持以客户需求为产品研发的原始驱动力和方向，坚定地打造一个有责任、有担当的一站式变现服务平台。"
    },
    about: {
      title: "网际星辰-公司简介",
      keywords: "网际星辰,网星传媒,网星,网际星辰公司怎么样",
      description: "网际星辰文化传媒（北京）有限公司是一家专注于移动互联网内容生态的高新技术企业，利用“AI+大数据”驱动智慧融媒体的发展。公司创业十年历程中，始终秉承科技创新的理念，坚持以客户需求为产品研发的原始驱动力和方向，坚定地打造一个有责任、有担当的一站式变现服务平台。"
    },
    xcpinyuepartner:{
      title:'星辰品阅',
      keywords:'星辰品阅-电商平台',
      description:'星辰品阅-电商平台',
    }
  },
  btn:{
    txt:'查看详情'
  },
  login:{
    exitType:['流量主','广告主'],
    projectList:[{name:'天琴',path:'/tianqin'},{name:'射手',path:"/sheshou"},{name:'临渊',path:'/linyuan'},{name:'仙后',path:'/xianhou'},{name:'泰坦',path:'/taitan'},{name:'联系我们',path:"/contact"},{name:'网际星辰',href:"http://www.star-media.cn/"}],
    msg:'© Copyright 2018 星辰+ All Rights Reserved  京ICP备11012669号-37'
  },
  home: {
    blink:{
      txt1:"媒体端入口",
      txt2:"广告主入口"
    },
    banTitle: "专业的<br/>一站式流量变现<br/>服务平台",
    banTips: "WEB(PC/H5)、APP",
    three:{
      num1: "天琴",
      num2: "射手",
      num3: "临渊",
      brief1: "PC/H5广告平台",
      brief2: "IN-APP广告平台",
      brief3: "基于AI的发现搜索平台",
    },
    yinqin:{
      title1: "仙后意图引擎",
      title2: "泰坦风控系统",
    }
  },
  xcp: {
    sIntro:
    "星辰+，是网际星辰旗下的一站式变现平台，对于PC，H5，APP，小程序等不同产品形式，以及不同的变现场景，都有相对应的样式，预算和接入方式来帮助开发者，团队核心成员来自于百度，小米等商业产品团队，有着丰富的产品和运营经验，星辰+平台现已接入近千家媒体，每日广告展现量过10亿。",
    more: "了解更多"
  }
};

export default zh;
